// components/ExportCustomers/ExportCustomersButton.jsx
import React, { useState } from "react";
import { Tooltip, IconButton, Button, CircularProgress } from "@material-ui/core";
import { GetApp as GetAppIcon } from "components/MaterialSymbol/MaterialIcons";
import CustomerService from "services/CustomerService";

export default function ExportCustomersButton({ dealerId }) {
    const [loading, setLoading] = useState(false);

    const disabled = !dealerId;

    const handleExport = async () => {
        if (disabled) return;
        setLoading(true);

        try {
            const response = await CustomerService.exportCSV(dealerId);

            const url = window.URL.createObjectURL(new Blob([response.data], { type: "text/csv" }));

            const a = document.createElement("a");
            a.href = url;
            a.download = "customers_export.csv";
            document.body.appendChild(a);
            a.click();
            a.remove();
            window.URL.revokeObjectURL(url);
        } catch (err) {
            console.error("Export failed", err);
            alert("Failed to export customers");
        } finally {
            setLoading(false);
        }
    };

    if (loading) {
        return (
            <Button
                variant="outlined"
                color="primary"
                size="small"
                disabled
                style={{ display: "flex", alignItems: "center" }}
            >
                <CircularProgress size={16} color="primary" />
                <span style={{ marginLeft: 8 }}>Generating...</span>
            </Button>
        );
    }

    return (
        <Tooltip
            title={disabled ? "Select a dealer to export customers" : "Export Customers"}
            placement="top"
        >
            <span>
                <IconButton
                    color="primary"
                    size="small"
                    disabled={disabled}
                    onClick={handleExport}
                    aria-label="export-customers"
                >
                    <GetAppIcon fontSize="small" />
                </IconButton>
            </span>
        </Tooltip>
    );
}
